import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {Grid} from '@material-ui/core';
import {Link} from "react-router-dom";

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    card: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});

function SimpleCard(props) {
    const {classes} = props;

    return (
        <Fragment>
            <Grid container className={classes.root} spacing={24} style={{textAlign: 'center'}}>
                <Grid item xs={12}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography variant="h5" component="h2">
                                Page not found :(
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                The link you clicked may be broken or the page may have been
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button variant="contained" color="primary" size="small" component={Link} to={"/"}>
                                Go To Homepage
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </Fragment>
    );
}

SimpleCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleCard);
